import axios from "axios";
import LocalstorageService from "./LocalstorageService";

const AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_BASEURL,
  headers: {
    "Content-Type": "application/json",
  },
});

AxiosInstance.interceptors.request.use(
  (config) => {
    const token = LocalstorageService.getLocalAccessToken();
    if (token) {
      config.headers["Authorization"] = token;
    }
    // if (!token) {
    //   window.location.href = "/Login";
    // }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

AxiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;

      const refreshToken = LocalstorageService.getRefreshToken();
      const email = LocalstorageService.getAuthEmail();

      if (refreshToken && email) {
        try {
          const response = await axios.post(
            `${process.env.REACT_APP_SERVER_BASEURL}/api/ClientAuth/RefreshToken`,
            { email, refreshToken },
            {
              headers: {
                "Content-Type": "application/json",
              },
            }
          );

          const result = response.data;
          if (result.isSuccess) {
            const accessToken = result.accessToken || result.token;
            LocalstorageService.setAuthTokens(
              accessToken,
              result.refreshToken,
              result.email || email
            );
            originalRequest.headers["Authorization"] =
              LocalstorageService.getLocalAccessToken();
            return AxiosInstance(originalRequest);
          }
        } catch {
          LocalstorageService.clearAuthTokens();
          window.location.href = "/Login";
        }
      }
    }

    return Promise.reject(error);
  }
);

export default AxiosInstance;
